import { SyntheticEvent, useState } from 'react';

import { SearchCriteriaType } from '../../type/SearchCriteriaType';
import { all } from '../../const/commonConst';

export type SelectedOffsegMasterInfoType = {
	selectedOffsegOrganizationInfo: SearchCriteriaType;
	selectedOffsegCarInfo: SearchCriteriaType;
	selectedOffsegDriverInfo: SearchCriteriaType;
};

const initSelectedOffsegMasterInfo = {
	selectedOffsegOrganizationInfo: all,
	selectedOffsegCarInfo: all,
	selectedOffsegDriverInfo: all,
};

/**
 * Offsegの選択したマスタデータの状態管理用カスタムフック
 */
export const useStateSelectedOffsegMasterInfo = () => {
	const [selectedOffsegMasterInfo, setSelectedOffsegMasterInfo] = useState<SelectedOffsegMasterInfoType>(initSelectedOffsegMasterInfo); // 選択したマスタ情報

	// 検索対象組織を変更した際の処理
	const onChangeOffsegOrganization = (event: SyntheticEvent<Element, Event>, value: SearchCriteriaType | null) => {
		if (value === null) {
			return;
		}

		setSelectedOffsegMasterInfo({ ...initSelectedOffsegMasterInfo, selectedOffsegOrganizationInfo: { id: value.id, label: value.label } });
	};

	// 検索対象車両を変更した際の処理
	const onChangeOffsegCar = (event: SyntheticEvent<Element, Event>, value: SearchCriteriaType | null) => {
		if (value === null) {
			return;
		}

		setSelectedOffsegMasterInfo({ ...selectedOffsegMasterInfo, selectedOffsegCarInfo: { id: value.id, label: value.label } });
	};

	// 検索対象ドライバーを変更した際の処理
	const onChangeOffsegDriver = (event: SyntheticEvent<Element, Event>, value: SearchCriteriaType | null) => {
		if (value === null) {
			return;
		}

		setSelectedOffsegMasterInfo({ ...selectedOffsegMasterInfo, selectedOffsegDriverInfo: { id: value.id, label: value.label } });
	};

	return {
		selectedOffsegMasterInfo,
		setSelectedOffsegMasterInfo,
		onChangeOffsegOrganization,
		onChangeOffsegCar,
		onChangeOffsegDriver,
	};
};
